export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7883.43cf6b1f.jpg";